
function LoadingSpinner() {
    return (<div className="loading-spinner">
        <div className="spinner"></div>
        <span>Loading&hellip;</span>
    </div>)
}

export default LoadingSpinner;